import * as API from "middleware/api";

export const filterEcheqsList = (params) => API.executeWithAccessToken("/list.echeqs", { ...params, extraInfo: false });

export const downloadEcheqsList = (filter) =>
    API.executeWithAccessToken("/download.echeqs.list", { ...filter, reportInfo: true });

export const sendEmitEcheq = (params) => API.executeWithAccessToken("/emit.echeq.pre.activity", { ...params });
export const signEmitEcheq = (params) => API.executeWithAccessToken("/emit.echeq.activity", { ...params });

export const sendEndorseEcheq = (params) =>
    API.executeWithAccessToken("/endorse.echeq.activity", {
        ...params,
    });

export const sendMultipleEndorseEcheq = (params) =>
    API.executeWithAccessToken("/endorse.multiple.echeq.activity", { ...params });

export const sendCesionEcheq = (params) =>
    API.executeWithAccessToken("/cesion.echeq.activity", {
        ...params,
    });

export const sendMultipleCesionEcheq = (params) =>
    API.executeWithAccessToken("/cesion.multiple.echeq.activity", {
        ...params,
    });

export const executeEcheqAction = (params) => API.executeWithAccessToken("/actions.echeqs", { ...params });

export const executeEcheqTransactionAction = (params) =>
    API.executeWithAccessToken("/actions.echeqs.send", { ...params });

export const executeEcheqMultipleAction = (params) =>
    API.executeWithAccessToken("/actions.echeqs.multiple.send", { ...params });

export const echeqDetailRequestMiddleware = (echeqId) => API.executeWithAccessToken("/detail.echeq", { id: echeqId });

export const amountEchecks = (params) => API.executeWithAccessToken("/echeq.readAmount", { ...params });

export const acceptRequestReturnEcheq = (params) => API.executeWithAccessToken("/accept.return.echeqs", { ...params });

export const bankedBeneficiary = (documentObject) => {
    const { document, type } = documentObject;
    return API.executeWithAccessToken("/banked.beneficiary", { document, type });
};

export const updateEcheckAmount = (params) => API.executeWithAccessToken("/echeq.updateAmount", { ...params });

export const solicitAvalRequest = (params) => API.executeWithAccessToken("/echeq.aval.solicitar", { ...params });

export const downloadMassiveTemplate = (params) =>
    API.executeWithAccessToken("/files.download.template", { ...params });
export const updateStateAvalRequest = (params) => API.executeWithAccessToken("/actions.echeqs", { ...params });

export const anulateAvalRequest = (params) => API.executeWithAccessToken("/echeq.aval-anulate.action", { ...params });

export const admitAvalRequest = (params) => API.executeWithAccessToken("/echeq.aval-admit.action", { ...params });

export const repudiateAvalRequest = (params) =>
    API.executeWithAccessToken("/echeq.aval-repudiate.action", { ...params });

export const validateMassiveEcheq = (params) => API.executeWithAccessToken("/load.echeq.massive", { ...params });

export const cancelEndorseEcheq = (params) =>
    API.executeWithAccessToken("/cancel.endorse.echeq", {
        ...params,
    });

export const requestCac = (params) => API.executeWithAccessToken("/echeq.request.cac", { ...params });

export const acceptReturnRejected = (params) =>
    API.executeWithAccessToken("/accept.return.rejected.echeq", { ...params });
